<template>
  <ul
    :id="
      depth < 1
        ? 'navigation_mid'
        : `menu_${slug}${
            path.match('used') && !slug.match('used') ? '_used' : ''
          }`
    "
    :class="depth < 1 ? 'mid_nav navigation' : 'sub-menu'"
    :style="depth > 0 ? 'display:none' : ''"
  >
    <li
      v-for="node in nodes"
      :key="`${node.slug}${path.match('used') ? '-used' : ''}`"
      :id="`menu-item-${node.slug}${path.match('used') ? '-used' : ''}`"
      :class="
        `menu-item menu-item-type-custom menu-item-object-custom menu-item-${
          node.slug
        }
        ${
          node.children.length ? ' menu-item-has-children' : ''
        } menu-item-depth-${depth}`
      "
    >
      <span
        v-if="node.children.length"
        class="menu-item-element"
        @click.stop.prevent="
          onMenuItem(`${node.slug}${path.match('used') ? '_used' : ''}`)
        "
      >
        <span class="nav_item_wrap">
          <!-- <span class="nav_title">{{ categoryName(node) }}</span> -->
          <router-link :to="lang ? '/' + lang + path + '/' + node.slug : path + '/' + node.slug" @click.native="onMenuClose" class="nav_title">{{ categoryName(node) }}</router-link>
        </span>
        <span
          class="seasidetms_resp_nav_toggle seasidetms_theme_icon_resp_nav_slide_down"
          :id="`menuico_${node.slug}`"
        ></span>
      </span>
      <router-link
        v-else
        class="menu-item-element"
        :to="
          lang ? '/' + lang + path + '/' + node.slug : path + '/' + node.slug
        "
        @click.native="onMenuClose"
      >
        <span class="nav_item_wrap">
          <span class="nav_title">{{ categoryName(node) }}</span>
        </span>
      </router-link>
      <MenuMobileNode
        v-if="node.children.length"
        :nodes="node.children"
        :depth="depth + 1"
        :path="`${path}/${node.slug}`"
        :slug="node.slug"
      />
    </li>
  </ul>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'MenuMobileNode',
  props: {
    nodes: {
      type: Array,
      required: true,
    },
    depth: {
      type: Number,
      required: false,
      default: 0,
    },
    path: {
      type: String,
      required: false,
      default: '/product-category',
    },
    slug: {
      type: String,
      required: false,
    },
  },
  computed: mapState(['menuMobile']),
  methods: {
    categoryName(cat) {
      return cat[`name_${this.$i18n.locale}`] || cat.name || '.....'
    },
    onMenuClose() {
      this.setMenuMobile(false)
    },
    onMenuItem(slug) {
      let el = document.getElementById(`menu_${slug}`)
      if (!el) return
      const closed = el.style.display === 'none'
      el.style.display = closed ? 'block' : 'none'
      el = document.getElementById(`menuico_${slug}`)
      if (!el) return
      let cls = el.className.split(/\s+/i)
      cls.forEach((c, i) => {
        if (c.match(/^seasidetms_theme_icon/)) {
          cls[i] = closed
            ? 'seasidetms_theme_icon_resp_nav_slide_up'
            : 'seasidetms_theme_icon_resp_nav_slide_down'
        }
      })
      el.className = cls.join(' ')
    },
    ...mapMutations(['setMenuMobile']),
  },
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.mobile_mm .sub-menu {
  margin-left: 20px !important;
}
</style>
